const doc = [({"da":({"js":({"admin":({"surveys":({"activation_button":({"activated":"Aktiveret", "deactivated":"Deaktiveret"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;